<!-- @format -->

<ticket-modal>
  <style>
    .status-link {
      color: blue;
      cursor: pointer;
    }
  </style>
  <div id="{ props.modalId }" class="modal js-modal">
    <div class="modal__bg js-modal-close"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <div class="modal_count_cotainer">
          <dl class="modal_count">
            <dt>解析文字数</dt>
            <dd>{ props.ticketRequire.length }</dd>
            <dt>
              消費カウント
              <span>※</span>
            </dt>
            <dd>
              { props.ticketRequire.count }
            </dd>
          </dl>
          <!-- prettier-ignore -->
          <p class="modal_count_notice" if="{ props.similarityCheck }">
            ※「類似チェック」が <strong>ON</strong> になっているため<br />
            　消費カウントは「<strong>2倍</strong>」となっています。
          </p>
          <p class="modal_count_notice" if="{ props.ticketRequire.msg }">
            <span each="{ line in props.ticketRequire.msg.split('\n') }">
              { line }
              <br />
            </span>
          </p>
          <div
            class="modal_count_notice"
            if="{ props.ticketRequire.isShortage }"
          >
            カウントが不足しているため解析をすることができません。
            <br />
            <a onclick="{ onMove }" class="status-link">こちら</a>
            からプランのアップグレードを行うか
            <br />
            「カウント追加購入」をしてください。
            <br />
            ※有料プランのチケットは翌月を迎えると改めて付与されます。
            <br />
          </div>
        </div>
        <!--/.modal_count_cotainer-->
        <button
          class="button button-primary"
          type="button"
          value="解析を開始する"
          onclick="{ props.onStartProcessing }"
          disabled="{ props.ticketRequire.msg != 0 || props.ticketRequire.isShortage }"
        >
          解析を開始する
        </button>
      </div>
      <!--/.modal__content_inner-->
      <a
        class="btn_close_modal js-modal-close"
        onclick="{ onClose }"
        style="cursor: pointer;"
      >
        <img src="/assets/img/common/icn_close_modal.svg" alt="閉じる" />
      </a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import di from "dependeny-injection";
    import routes from "@model/routes.js";

    export default {
      onClose(e) {
        window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
      },
      onMove(e) {
        di.router.push(routes.makePath("setting-status"));
      },
    };
  </script>
</ticket-modal>
